import { useParams } from 'react-router-dom';

type PathwayScenarioUrl = {
  scenarioId: string;
};

const usePathwayScenarioId = () => {
  const params = useParams<PathwayScenarioUrl>();
  return Number(params.scenarioId);
};

type MaybePathwayScenarioUrl = {
  scenarioId?: string;
};

const useMaybePathwayScenarioId = () => {
  const params = useParams<MaybePathwayScenarioUrl>();
  return params.scenarioId ? Number(params.scenarioId) : undefined;
};

// The EF-scenario detail route (`scenarios/:scenarioId`) — the
// emission-accounting scenario, distinct from the pathway concept above. Reads
// the same param name but in its own route subtree.
type ScenarioUrl = {
  scenarioId: string;
};

const useScenarioId = () => {
  const params = useParams<ScenarioUrl>();
  return Number(params.scenarioId);
};

export { usePathwayScenarioId, useMaybePathwayScenarioId, useScenarioId };
